import {
  Trash2, Sofa, BedDouble, Refrigerator, Waves, Warehouse, Home, Key,
  Leaf, Hammer, Truck, PackageCheck, Zap, Building2, HelpCircle,
} from "lucide-react";

const MAP = {
  Trash2, Sofa, BedDouble, Refrigerator, Waves, Warehouse, Home, Key,
  Leaf, Hammer, Truck, PackageCheck, Zap, Building2,
};

export default function Icon({ name, className = "w-8 h-8" }) {
  const C = MAP[name] || HelpCircle;
  return <C className={className} strokeWidth={2.2} />;
}
